import React from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async';

const HelmetSco = ({ title, description, imag,jsonLd }) => {
    const imagLogo="../../public/img/alphai-logo.webp"
    // const jsonLd = {
    //     "@context": "https://schema.org",
    //     "@type": "Article",
    //     "headline": title,
    //     "author": {
    //         "@type": "Person",
    //         "name": author
    //     },
    //     "datePublished": datePublished,
    //     "description": description,
    //     "image": "https://example.com/image.jpg", // Replace with your image URL
    //     "publisher": {
    //         "@type": "Organization",
    //         "name": "My Blog",
    //         "logo": {
    //             "@type": "ImageObject",
    //             "url": "https://example.com/logo.png" // Replace with your logo URL
    //         }
    //     }
    // };
    return (
        <HelmetProvider>
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="author" content="Alphai Solutions" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={imagLogo} />
            <link rel="canonical" href={window.location} />

            <link rel="preload" as="image" href={imag} />
            {jsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            )}
        </Helmet>
        </HelmetProvider>
    )
}

export default HelmetSco
